import { addIgnoreLabel } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/addIgnoreLabel";
import { IgnoreZone } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { IgnoreZoneMetricOption } from "../types";

/** Product/metric rows from GET ignore_zones (excludes Ignore All template row). */
export const buildAvailableMetrics = (
  apiRows: IgnoreZone[]
): IgnoreZoneMetricOption[] => {
  const labeled = addIgnoreLabel(apiRows) as IgnoreZone[];

  return labeled
    .filter((row) => Number(row.zone_type) !== 0)
    .map((row) => ({
      metricId: Number(row.metric_id),
      label: row.label,
      labelDisplayName: row.label_display_name,
      zoneType: Number(row.zone_type),
    }));
};

export const getAllMetricIds = (metrics: IgnoreZoneMetricOption[]): number[] =>
  metrics.map((m) => m.metricId);

export const getAssignmentDisplayLabels = (
  assignment: { isIgnoreAll: boolean; metricIds: number[] },
  availableMetrics: IgnoreZoneMetricOption[]
): string[] => {
  if (assignment.isIgnoreAll) {
    return availableMetrics.map((m) => m.labelDisplayName);
  }

  const idSet = new Set(assignment.metricIds);
  return availableMetrics
    .filter((m) => idSet.has(m.metricId))
    .map((m) => m.labelDisplayName);
};
